import * as React from 'react';
import Typography from '../Typography';
import QuickJumpInput from './QuickJumpInput';
import QuickJumperWrapper from './QuickJumperWrapper';
/**
 * 页码直接跳转组件
 *
 * @param {} props
 */
export default function QuickJumper(props) {
    var onChange = props.onChange, totalPage = props.totalPage;
    var handleKeyDown = function (event) {
        var pageValue = parseInt(event.target.value, 10);
        if (event.keyCode === 13) {
            if (pageValue >= 1 && pageValue <= totalPage) {
                onChange(pageValue);
            }
            if (pageValue > totalPage) {
                onChange(totalPage);
            }
            var target = event.target;
            target.value = '';
        }
    };
    return (React.createElement(QuickJumperWrapper, null,
        React.createElement(Typography, { type: "caption" }, "\u8DF3\u81F3"),
        React.createElement(QuickJumpInput, { disabled: props.disabled, onKeyDown: handleKeyDown, onChange: function (event) {
                event.stopPropagation();
            } }),
        React.createElement(Typography, { type: "caption" }, "\u9875")));
}
//# sourceMappingURL=QuickJumper.js.map